import { RequestConfig } from '~/common/services/requests';
import { Role } from '../../../../types';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const getUserRoles = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Role[]> | undefined> =>
  constructGet<NonPaginatedResponse<Role[]>>(`${USER_BASE_PATH}/roles/get`, {
    params,
  });
